import React, { useRef, useCallback } from "react"
import PropTypes from "prop-types"
import ChartNodeMolecule from "views/molecules/organization/ChartNodeMolecule"
import classNames from "classnames"

const ChartNodesChildrenMolecule = ({
  node,
  isParentColumn,
  hidden,
  position,
}) => {
  const refs = useRef([])

  const closeSiblings = useCallback(() => {
    Object.values(refs.current).forEach((ref) => ref?.closeChildren())
  }, [])

  if (!node?.children || node.children.length === 0) return null

  return (
    <ul
      className={classNames(position, {
        hidden,
        column: isParentColumn,
      })}
    >
      {node.children.map((child) => (
        <ChartNodeMolecule
          node={child}
          key={child.id}
          ref={(element) => {
            refs.current[child.id] = element
          }}
          onCloseSiblings={closeSiblings}
        />
      ))}
    </ul>
  )
}

ChartNodesChildrenMolecule.propTypes = {
  node: PropTypes.object.isRequired,
  isParentColumn: PropTypes.bool.isRequired,
  hidden: PropTypes.bool.isRequired,
  position: PropTypes.string,
}

export default ChartNodesChildrenMolecule

ChartNodesChildrenMolecule.defaultProps = {
  position: "bottom",
}
